export const getAsset = (url: string | undefined) => {
  if (url) return `${process.env.REACT_APP_BASE_CDN_URL}${url}`;
  return "default_img";
};
